export const FORM_QA = 'formStyleForm';
export const FORM_FIELDS_QA = 'formStyleFormFields';
export const BUTTON_QA = 'formStyleButton';
export const HEADLINE_TEXT_QA = 'formStyleHeadlineText';
export const FORM_IMAGE_QA = 'formImage';
export const ERRORS_QA = 'formStyleErrors';
export const TEXT_ELEMENT_QA = 'formStyleTextElement';
export const TICKET_EMAIL_QA = 'ticketEmail';
export const STEPPER_QA = 'formStyleStepper';
export const SESSION_DETAILS_QA = 'formStyleSessionDetails';
export const SECONDARY_BUTTON_QA = 'formStyleSecondaryButton';

export const FONT_LABEL_QA = 'Font';
export const COLOR_LABEL_QA = 'Color';
export const ALIGNMENT_LABEL_QA = 'Alignment';
export const LINKS_LABEL_QA = 'Links';
export const SPACING_LABEL_QA = 'Spacing';
export const BACKGROUND_LABEL_QA = 'Background';
export const MODAL_SIZE_LABEL_QA = 'Modal Size';
export const CLOSE_BUTTON_LABEL_QA = 'Close Button';
export const TITLE_QA = 'Title';
export const INFORMATION_QA = 'Information';
export const TAG_LABEL_QA = 'Tag Text';
export const TAG_BACKGROUND_QA = 'Tag Background';
export const TAG_BORDER_QA = 'Tag Border';
export const BADGE_LABEL_QA = 'Badge Text';
export const BADGE_BACKGROUND_QA = 'Badge Background';
export const BADGE_BORDER_QA = 'Badge Border';
